import { render, staticRenderFns } from "./check-info.vue?vue&type=template&id=26367164&scoped=true"
import script from "./check-info.vue?vue&type=script&lang=js"
export * from "./check-info.vue?vue&type=script&lang=js"
import style0 from "./check-info.vue?vue&type=style&index=0&id=26367164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26367164",
  null
  
)

export default component.exports